import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import logo from "../../assets/images/logo.png";
import search from "../../assets/images/search.png";
import {createLogoutRequest} from "../../actions/logoutAction";
import { sendFriendRequest, respondTorequest, unfriendRequest, cancelfriendRequest, requestSearchFriend} from "../../actions/friendAction";
import {getNotificationCount, getNotificationlist, updateReadNotification, getFriendNotificationlist} from "../../actions/notificationAction";
import { changeLanguage } from "../../actions/languagechangeAction";
import FriendNotification from "./friendnotification"
import pathList from "../../helpers/pathList";
import { encrypt } from "../../helpers/CryptoJs";
import './Header.css';
import iconPath from "../../helpers/iconHelper";
import { getlanguagelist, getlanguage, changelanguage} from "../../helpers/changelanguage";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import $$ from 'jquery'

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userImage              : '',
      userName               : '',
      userMembership         : '',
      userId                 : '',
      isToggle               : false,
      friend_notification    : 0,
      other_notification     : 0,
      total_notifiaction     : 0,
      chat_notification      : 0,
      groupchat_notification : 0,
      notifications          : [],
      notificationsfriend    : [],
      searchresultlist       : [],
      is_open                : 'none',
      is_spin                : 'fa-spin',
      pagination             : 0,
      is_open_friend         : 'none',
      is_spin_friend         : 'fa-spin',
      pagination_friend      : 0,
      search_name            : '',
      is_open_search         : 'none',
      openDialog             : false,
      serch_sel_frndid       : 0,
      serch_sel_frndstatus   : null,
      language               : getlanguage()
     };

    this.logout             = this.logout.bind(this);
    this.toggleDiv          = this.toggleDiv.bind(this);
    this.viewChat           = this.viewChat.bind(this);
    this.showNotification   = this.showNotification.bind(this);
    this.showNotificationFriend = this.showNotificationFriend.bind(this);
    this.chk_scroll         = this.chk_scroll.bind(this);
    this.reDirection        = this.reDirection.bind(this);
    this.chk_scroll_friend  = this.chk_scroll_friend.bind(this);
    this.handleChange       = this.handleChange.bind(this);
    this.sendFriendRequest  = this.sendFriendRequest.bind(this);
    this.handleClose        = this.handleClose.bind(this);
    this.openApp            = this.openApp.bind(this);
    this.gotoFriend         = this.gotoFriend.bind(this);
    this.gotoAccount        = this.gotoAccount.bind(this);
  }
  componentDidMount(){
   this.props.getNotificationCount();
   $$('#notify_ul').bind('scroll',this.chk_scroll);
   $$('#notify_friend_ul').bind('scroll',this.chk_scroll_friend);
  
  
    this.setState({
      userName       : this.props.currentUserDetails.user.first_name,
      userImage      : this.props.currentUserDetails.user.image,
      userId         : this.props.currentUserDetails.user.id,
      userMembership : this.props.currentUserDetails.user.membership,
      toggle_menu    : ''
    })
  }
  chk_scroll(e){
    var elem = $(e.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
    { 
      this.setState({
        is_spin_friend : 'fa-spin',
        pagination : this.state.pagination + 1
      },function(){
        this.props.getNotificationlist(this.state.pagination);  
      })
      
    }
  }

  chk_scroll_friend(e){
    var elem = $(e.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight())
    { 
      this.setState({
        is_spin_friend : 'fa-spin',
        pagination_friend : this.state.pagination_friend + 1
      },function(){
        this.props.getFriendNotificationlist(this.state.pagination_friend);  
      })
      
    }
  }

  reDirection(obj){
     let param = {
      id            : obj.id,
      content_type  : obj.content_type,
      content_id    : obj.content_id,
      link          : obj.link,
      link_type     : obj.link_type,
    }
    this.props.updateReadNotification(param); 
  }
  UNSAFE_componentWillReceiveProps(nextProps){ 
  
    if(this.props.respondtorequest != nextProps.respondtorequest){
      ToastsStore.success(`Friend request ${nextProps.respondtorequest.status}`);

      if(this.state.is_open_search == 'block'){
        $$("#serchrow_img_"+nextProps.respondtorequest.searchrow_id).attr('src',nextProps.respondtorequest.status == 'ACCEPTED' ? iconPath['FRIEND'] : iconPath['ADDFRIEND']);
        $$("#serchrow_status_"+nextProps.respondtorequest.searchrow_id).html(nextProps.respondtorequest.status == 'ACCEPTED' ? 'ACCEPTED' : 0);
        this.setState({ openDialog : false })
      }else{
        $$("#request_"+nextProps.respondtorequest.sender_id).remove();
        this.setState({
          is_open_friend : 'false'
        })
      }
      
    }else if(this.props.unfriendrequest != nextProps.unfriendrequest){
      $$("#serchrow_img_"+nextProps.unfriendrequest.searchrow_id).attr('src',iconPath['ADDFRIEND']);
      $$("#serchrow_status_"+nextProps.unfriendrequest.searchrow_id).html(0);
      ToastsStore.success(`UnFriend`);
     
    }else if(this.props.cancelfriendrequest != nextProps.cancelfriendrequest){
      $$("#serchrow_img_"+nextProps.cancelfriendrequest.searchrow_id).attr('src',iconPath['ADDFRIEND']);
      $$("#serchrow_status_"+nextProps.cancelfriendrequest.searchrow_id).html(0);
      ToastsStore.success('Cancel request');
     
    }else if(this.props.sendfriendrequest != nextProps.sendfriendrequest){
      $$("#serchrow_img_"+nextProps.sendfriendrequest.searchrow_id).attr('src',iconPath['PENDINGFRIEND']);
      $$("#serchrow_status_"+nextProps.sendfriendrequest.searchrow_id).html('PENDING');
      ToastsStore.success('Friend request send');
    }

    if(this.props.searchresult != nextProps.searchresult){
      this.setState({
        searchresultlist : nextProps.searchresult,
        is_open_search   : window.location.href.includes('search') ? "none" : 'block'
      })
    }

    if(nextProps.currentUserDetails != this.props.currentUserDetails){
      this.setState({
        userName       : nextProps.currentUserDetails.user.first_name,
        userImage      : nextProps.currentUserDetails.user.image,
        userId         : nextProps.currentUserDetails.user.id,
        userMembership : nextProps.currentUserDetails.user.membership,
        toggle_menu    : ''
      })
    }

    if((nextProps.notificationCount != null) || (nextProps.notificationCount != this.props.notificationCount)){
      this.setState({
        friend_notification    : nextProps.notificationCount.friend_request,
        other_notification     : nextProps.notificationCount.notification_without_friendrequest,
        total_notifiaction     : nextProps.notificationCount.notification_counter,
        chat_notification      : nextProps.notificationCount.chat_counter,
        groupchat_notification : nextProps.notificationCount.groupchat_counter,
      })
    }

   
    if(nextProps.notifications != this.props.notifications){
      let notificationsObj = this.state.notifications;
      if(this.state.pagination == 0){
        notificationsObj = [...nextProps.notifications];
      }else{
        Object.keys(nextProps.notifications).map((key) => {
          notificationsObj.push(nextProps.notifications[key]);
        });
      }
      this.setState({
        notifications : notificationsObj,
        is_spin       : "",
       
      });
    }

    if(nextProps.notificationsfrnd != this.props.notificationsfrnd){
      let notificationsfrndObj = this.state.notificationsfrnd;
      if(this.state.pagination_friend == 0){
        notificationsfrndObj = [...nextProps.notificationsfrnd];
      }else{
        Object.keys(nextProps.notificationsfrnd).map((key) => {
          notificationsfrndObj.push(nextProps.notificationsfrnd[key]);
        });
      }
      this.setState({
        notificationsfriend : notificationsfrndObj,
        is_spin_friend       : "",
       
      });
    }

    if(nextProps.read != this.props.read){
      if(nextProps.read.link_type == 'POST'){
        this.setState({
          is_open : 'none'
        })
        this.props.history.push(`/post/${encrypt(nextProps.read.content_id)}`);
      }else if(nextProps.read.link_type == 'ALBUM'){
        this.setState({
          is_open : 'none'
        })
        this.props.history.push(`/album/${encrypt(nextProps.read.content_id)}`);
      }else{
        this.openApp();
      }
    }

    if(this.props.currentlanguagelist != nextProps.currentlanguagelist){
      window.location.reload();

    }
  }
  toggleDiv(){
    this.setState({isToggle: !this.state.isToggle});
  }
  logout() {
    this.props.createLogoutRequest(this.state);
  }
  gotoAccount() {
    this.props.history.push(`/user/${encrypt(this.state.userId)}`);
  }
  showNotification(){
    this.setState({
      is_open       : (this.state.is_open == 'none') ? "block" : 'none'
    },function(){
      if(this.state.is_open == 'block'){
        this.props.getNotificationlist(0);
      }
    });
   
  }

  showNotificationFriend(){
    this.setState({
      is_open_friend       : (this.state.is_open_friend == 'none') ? "block" : 'none'
    },function(){
      if(this.state.is_open_friend == 'block'){
        this.props.getFriendNotificationlist(0);
      }
    });
   
  }

  respondtorequest(status,friendId){
    let param = {
      sender_id : (friendId === undefined) ? this.state.serch_sel_frndid : friendId,
      status    : status
    };
    this.props.respondTorequest(param);
  }

  viewChat(){
    this.props.history.push(`/chat/0`);
  }

  handleChange(e) {
   
    if(e.target.name == "search_name"){
      localStorage.setItem('search_name', e.target.value);
      this.setState({
        [e.target.name]: e.target.value,
      },function(){
        if(this.state.search_name.length >= 3){
          let param = {
            search_param : this.state.search_name
          };
          this.props.requestSearchFriend(param);
        }else if(this.state.search_name.length == 0){
          this.setState({
            is_open_search : 'none'
          })
        }
      });
    }else if(e.target.name == "language"){
      changelanguage(e.target.value);
      this.props.changeLanguage(e.target.value);
    }
  }
  sendFriendRequest(id){

    let friendstatus = $$("#serchrow_status_"+id).html();
    if(friendstatus == 'PENDING'){
      //cancel
      this.props.cancelfriendRequest({receiver_id : id});
    }else if(friendstatus == 'ACCEPTED') {
      //unfriend
      this.props.unfriendRequest({friend_id : id});
    }else if(friendstatus == 'PENDING RECEIVER'){
      //ACCECPT or DECLINE
      this.handleClose(id);
    }else{
      //send request
      this.props.sendFriendRequest(id);
    }
      
  }
  handleClose(id){
    this.setState({
      serch_sel_frndid : id,
      openDialog       : this.state.openDialog === true ? false : true
    })
  }

  openApp(){
    $("#appModal").modal('show');
  } 
  gotoFriend(friend){ 
    this.setState({
      is_open_search : 'none',
      search_name    : '',
    },function(){
      this.props.history.push(`/user/${encrypt(friend)}`);
    })
    
  }


  render() {
    let  languagelist           = getlanguagelist();
    let  notificationlist       = this.state.notifications || [];
    let  notificationlistfriend = this.state.notificationsfriend || [];
    let  searchresultlist       = this.state.searchresultlist || [];
    
    return (
      <div className="header_block">
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} lightBackground />
        <div className="header_logo">
          <Link to="/feed" className="back-btn">
            <img src={logo}/>
          </Link>
        </div>
        <div className="header_area" onClick={this.toogleMenu}>
          <form method="post" action="#" className="search_form">
            <input
              type="text"
              name="search_name"
              id="rest_name" 
              value={this.state.search_name}
              placeholder={languagelist.searchcontent}
              onChange = {this.handleChange}
              />
          </form>
            <div className="search_result_box" style={{display : this.state.is_open_search}}>
              
                <h3>{languagelist.searchresult}  </h3>
                <h4 className="all_notify">{(searchresultlist.length > 0) ? searchresultlist.length : 0 }</h4>
                <div className="clearfix"></div>
                <ul id="notify_friend_ul">
                { 
                  (searchresultlist.length > 0) ? 
                  searchresultlist.map((notify,index) => {
                    
                    return (
                      (index <= 5) ?
                      <li key={index} >
                          <img src = {notify.image} 
                               alt={notify.full_name}
                               onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER']
                               }} 
                               className={(notify.membership == 'GOLD') ? "gold_user notify_user" : "notify_user"} 
                          /> 
                          <div className="notify_detail">
                              <strong><Link to={void(0)} onClick={()=>this.gotoFriend(notify.id)}>{notify.full_name}</Link></strong>
                              <span>{notify.state}, {notify.country_name}</span>
                          
                               
                              
                          </div> 
                          <span id={`serchrow_status_${notify.id}`} style={{display : 'none'}}>{notify.already_friend}</span>
                         
                          <a href={void(0)} onClick={()=>this.sendFriendRequest(notify.id)}>
                            
                            {(notify.already_friend == 'ACCEPTED')  ? 
                              <img src={iconPath['FRIEND']} id={`serchrow_img_${notify.id}`}/>
                              :
                              ((notify.already_friend == 'PENDING RECEIVER') || (notify.already_friend == 'PENDING')) ? 
                              <img src={iconPath['PENDINGFRIEND']} id={`serchrow_img_${notify.id}`}/>
                                : <img src={iconPath['ADDFRIEND']} id={`serchrow_img_${notify.id}`}/>
                            }
                          </a>
                              
                          <div className="clearfix"></div>
                      </li>
                      : null
                    )
                   
                  })
                  : null
                  }
                  {(searchresultlist.length > 0) ? 
                    <li className="viewall"><Link to ="/search">{languagelist.view_all}</Link></li>
                    : null 
                  }
                    

                    <Dialog
                      open={this.state.openDialog}
                      onClose={this.handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogActions>
                        <Button onClick={()=>this.respondtorequest('ACCEPTED')} color="primary">
                          ACCEPT
                        </Button>
                        <Button onClick={()=>this.respondtorequest('DECLINE')} color="secondary" autoFocus>
                          DECLINE
                        </Button>
                      </DialogActions>
                    </Dialog>
                </ul>
              </div>

             
          <div className="header_right">
          <div className="language_section pull-left hidden-xs">
                    <select name="language" value={this.state.language} onChange={this.handleChange}>
                      <option value="en">English</option>
                      <option value="so" >Somali</option>
                    </select>
            </div>
            <div className="language_section2 pull-right hidden-lg">
                    <select name="language" value={this.state.language} onChange={this.handleChange}>
                      <option value="en">En</option>
                      <option value="so" >So</option>
                    </select>
            </div>
            <div className="header_user" onClick={this.toggleDiv}>
              <div className="header_pic">
                {
                  (this.state.userImage != '') 
                  ? 
                  <img className={(this.state.userMembership == 'GOLD') ? "gold_user" : ""} src={this.state.userImage} onError = {(e) => {
                    e.target.src = iconPath['DEFAULTUSER'] 
                  }}/> 
                  : 
                  <img src={iconPath['DEFAULTUSER']}/>
                }
              {/*   <div className="user_status"></div> */}
              </div>
              <div className="header_details">
                <h3>{this.state.userName}</h3>
                
              </div>
              <ul className={"user_dropdown " + (this.state.isToggle ? 'is-collapsed' : '')} ref={this.userDropdown}> 
                
                <li onClick={this.gotoAccount} >
                  <a className="back-btn">{languagelist.account}</a>
                </li>
                <li onClick={this.logout} >
                  <a id="logout2">{languagelist.logout}</a>
                </li>
              </ul>
            </div>
            <a className="header_home setting_icon"  onClick={this.openApp}> </a>
            <a className="header_home chat_icon" onClick={this.viewChat}>
              { 
                ((this.props.chatcounter > 0) || (this.state.chat_notification > 0))? 
                  <div className="count">{this.props.chatcounter || this.state.chat_notification}</div>
                : null 
              }
            </a>
            <a className="header_home friendreq_icon" onClick={this.showNotificationFriend} style={{cursor : 'pointer'}}>
            
                {(this.state.friend_notification > 0) ? 
                  <div className="count">{this.state.friend_notification}</div>
                  : null 
                }
            </a>
            <div className="notify_box_friend" style={{display : this.state.is_open_friend}}>
               <div className="riangle-up"></div>
                <h3>{languagelist.notification}  
                  {/* <i className={`fa fa-spinner ${this.state.is_spin_friend}`}></i> */}
                </h3>
                <h4 className="all_notify">{this.state.friend_notification}</h4>
                <div className="clearfix"></div>
                <ul id="notify_friend_ul">
                { 
                  (notificationlistfriend.length > 0) ? 
                  notificationlistfriend.map((notify,index) => {
                    return (
                      <li key={index} id={`request_${notify.link}`} className={(notify.view_status == '0') ? 'unread_notification' : ''} >
                          <img src = {notify.left_image} 
                               alt={notify.full_name}
                               onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER']
                               }} 
                               className={(notify.membership == 'GOLD') ? "gold_user notify_user" : "notify_user"} 
                          /> 
                          <div className="notify_detail">
                              <b><Link to={`/user/${encrypt(notify.link)}`}>{notify.full_name}</Link></b>
                              <span>{notify.country_name}</span>
                              <p className="mutual_friend">
                                <img src="/assets/images/user_group.png"/> {notify.mutual_friend} {languagelist.mutualfrnd}
                              </p>
                              
                          </div> 
                                <div className="notify_action">
                                    <a className="addnew_btn" href={void(0)} onClick={()=>this.respondtorequest('ACCEPTED',notify.link)} ><i className="fa fa-check" data-toggle="tooltip" title={languagelist.accept} aria-hidden="true"></i> Accept</a>
                                    <div className="clearfix"></div>
                                    <a href={void(0)} className="addnew_btn" onClick={()=>this.respondtorequest('DECLINE',notify.link)}><i className="fas fa-times" data-toggle="tooltip" title={languagelist.reject} aria-hidden="true"></i> Reject </a>
                                </div>
                             
                         
                          <div className="clearfix"></div>
                      </li>
                    )
                  })
                  : null
                  }
                    
                </ul>
              </div>
            <div className="notify_section pull-right">
              <a className="header_notification notifi_icon" onClick={this.showNotification} style={{cursor : 'pointer'}}>
                {(this.state.other_notification > 0) ? 
                  <div className="count">{(this.state.other_notification > 50) ? `50+` : this.state.other_notification}</div>
                  : null 
                }
              </a>
              <div className="notify_box" style={{display : this.state.is_open}}>
                <div className="riangle-up"></div>
                <h3>{languagelist.notification}  
               {/*  <i className={`fa fa-spinner ${this.state.is_spin}`}></i> */}
                </h3>
                <h4 className="all_notify">{this.state.other_notification}</h4>
                <div className="clearfix"></div>
                <ul id="notify_ul">
                { 
                  (notificationlist.length > 0) ? 
                  notificationlist.map((notify,index) => {
                    return (
                      <li key={index} className={(notify.view_status == '0') ? 'unread_notification' : ''} onClick={()=>this.reDirection(notify)}>
                          <img src = {notify.left_image} 
                               alt={notify.full_name}
                               onError = {(e) => {
                                e.target.src = iconPath['DEFAULTUSER']
                               }} 
                               className={(notify.membership == 'GOLD') ? "gold_user notify_user" : "notify_user"} 
                          /> 
                          <div className="notify_detail">
                              <b>{notify.full_name}</b>
                              <span>{notify.post_date}</span>
                              <p dangerouslySetInnerHTML={{ __html: ' '+ notify.short_description + ' ' }}></p>
                          </div>
                          {(notify.right_thumbnail != '') ?    
                               <img src = {(notify.right_thumbnail_type == 'VIDEO') ? notify.right_thumbnail.replace(".mp4", ".jpg") : notify.right_thumbnail} 
                                 alt={notify.link_type}
                                 onError = {(e) => {
                                  e.target.src = iconPath['BREAKIMAGE']
                                 }} 
                                 className="notify_pot" 
                               /> 
                          : null
                          }
                        
                          <div className="clearfix"></div>
                      </li>
                    )
                  })
                  : null
                  }
                    
                </ul>
              </div>
            </div>

           {/*  <a className="header_home timeline_icon" onClick={this.openApp}></a> */}
            {/* <a className="header_search">
              <img src={search}/>
            </a>
 */}
            

          </div>
        {/*   <FriendNotification /> */}
        </div>

             
      </div>
    );
  };
}
const mapStateToProps = state => {
  return {
          currentUserDetails  : state.login,
          loggedOutUser       : state.logout.loggedUser,
          notificationCount   : state.countnotification.notificationCounter,
          chatcounter         : state.chatuserlist.chatList.chat_counter, 
          notifications       : state.notificationlist.notificationList.details, 
          read                : state.readnotification.readNotification,
          notificationsfrnd   : state.friendnotificationlist.friendnotificationList.details, 
          respondtorequest    : state.requestrespond.requestRespond,
          searchresult        : state.searchfriend.searchFriend,
          sendfriendrequest   : state.friendrequest.friendRequest,
          unfriendrequest     : state.unfriendrequest.requestUnfriend,
          cancelfriendrequest : state.requestcancel.requestCancel,
          currentlanguage     : state.currentlanguage.currentlanguage.language,
          currentlanguagelist : state.currentlanguage.currentlanguage.languagelist,      
        }
}
const mapDispatchToProps = dispatch => {
  return {
    createLogoutRequest       : bindActionCreators(createLogoutRequest, dispatch),
    getNotificationCount      : bindActionCreators(getNotificationCount, dispatch),
    getNotificationlist       : bindActionCreators(getNotificationlist, dispatch),
    updateReadNotification    : bindActionCreators(updateReadNotification, dispatch),
    getFriendNotificationlist : bindActionCreators(getFriendNotificationlist, dispatch),
    respondTorequest          : bindActionCreators(respondTorequest, dispatch),
    requestSearchFriend       : bindActionCreators(requestSearchFriend, dispatch),
    sendFriendRequest         : bindActionCreators(sendFriendRequest, dispatch),
    unfriendRequest           : bindActionCreators(unfriendRequest, dispatch),
    cancelfriendRequest       : bindActionCreators(cancelfriendRequest, dispatch),
    changeLanguage            : bindActionCreators(changeLanguage , dispatch),

  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));